import qs from 'qs'
import { ItemsService } from './base-service'
import { HALApiService } from './hal-api.service'

export const storageInventoryService = new ItemsService('/storage/inventory-service', HALApiService, qs)
